document.addEventListener('click', async function(event) {
  const target = event.target.closest('.custom-ajx-home');
  if (!target) return; // not an Add to Cart button
  event.preventDefault();

  const form = target.closest('.custom-add-to-cart-form-pro');
  const variantInput = form.querySelector('.cust_iddd');
  const loader = form.querySelector('.loader-ajax');
  const variantID = variantInput ? variantInput.value : null;
  if (!variantID) return;

  // --- Show loader inside button
  const originalText = target.innerHTML;
  const loaderClone = loader.cloneNode(true);
  loaderClone.style.display = 'inline-block';
  loaderClone.style.width = '22px';
  loaderClone.style.height = '22px';
  loaderClone.style.verticalAlign = 'middle';
  loaderClone.style.margin = '0 auto';

  loader.style.display = 'none';
  target.innerHTML = '';
  target.appendChild(loaderClone);
  target.disabled = true;

  try {
    // STEP 1 — Add product to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        quantity: 1,
        id: variantID
      })
    });

    // STEP 2 — Fetch updated cart sections
    const sectionsResponse = await fetch('/cart?sections=cart-notification-default,cart-notification-product,cart-notification-button');
    const sectionsJSON = await sectionsResponse.json();

    // STEP 3 — Replace HTML for all relevant sections
    ['cart-notification-default', 'cart-notification-product', 'cart-notification-button'].forEach(id => {
      const sectionHTML = sectionsJSON[id];
      if (sectionHTML) {
        const container = document.querySelector(`#${id}`);
        if (container) {
          container.innerHTML = new DOMParser().parseFromString(sectionHTML, 'text/html').body.innerHTML;
        }
      }
    });

    // STEP 4 — Fetch updated cart.js data
    const cartResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    });
    const cart = await cartResponse.json();

    // STEP 5 — Update cart count bubble
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.textContent = cart.item_count;

    // STEP 6 — Hide “Cart is empty” message if needed
    const emptyState = document.querySelector('.cart-empty');
    if (emptyState) {
      if (cart.item_count > 0) {
        emptyState.style.display = 'none';
      } else {
        emptyState.style.display = 'block';
      }
    }

    // STEP 7 — Open the cart drawer if available
    if (typeof openCartDrawer === 'function') openCartDrawer();

    // STEP 8 — Initialize motivator product logic (if exists)
    if (typeof initMotivatorProduct === 'function') initMotivatorProduct();

  } catch (error) {
    console.error('Add to Cart Failed:', error);
  } finally {
    // STEP 9 — Reset button loader
    target.innerHTML = originalText;
    target.disabled = false;
    loader.style.display = 'none';
  }
});
